import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedEffects } from './+state/effects/shared.effects';
import { SiteWideUserSessionEffects } from './+state/effects/site-wide-user-session.effects';
import * as fromShared from './+state/reducer/shared.reducer';
import { StateFacade } from './+state/state.facade';
import { SessionService } from './services/session/session.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromShared.SHARED_FEATURE_KEY, fromShared.reducer),
    EffectsModule.forFeature([SharedEffects, SiteWideUserSessionEffects])
  ],
  exports: [],
  providers: [StateFacade, SessionService]
})
export class SharedModule {}
